import { createStore } from 'zustand/vanilla';
import { persist, createJSONStorage } from "zustand/middleware";

interface GridPinState {
    orderGroups: {
        // 주문관리
        right: string[];
        left: string[];
    };
    shippingManagement: {
        // 배송관리
        right: string[];
        left: string[];
    };
    issueOrders: {
        // 취소 / 반품 / 교환관리
        right: string[];
        left: string[];
    };
    refundOrders: {
        // 환불 관리
        right: string[];
        left: string[];
    };
    groupOrders: {
        // 공구주문
        right: string[];
        left: string[];
    }
}

export interface GridPinStore extends GridPinState {
    setGridPinStore: (gridPins: GridPinState) => void
    clearStore: () => void;
}
// const checkBoxGrouping = GRID_CHECKBOX_SELECTION_COL_DEF.field
// const treeGrouping = GRID_TREE_DATA_GROUPING_COL_DEF_FORCED_PROPERTIES.field

const initializeState: GridPinState = {
    orderGroups: {
        right: ['status', 'order-group-action', 'partial-refund'],
        left: []
    },
    shippingManagement: {
        right: ['status', 'isMailed2Manufacturer', 'partial-refund'],
        left: []
    },
    issueOrders: {
        right: ['actions', 'status', 'partial-refund'],
        left: []
    },
    refundOrders: {
        right: ['detailInfo', 'status', 'partial-refund'],
        left: []
    },
    groupOrders: {
        right: ['status'],
        left: []
    }
}

export const gridPinStore = createStore<GridPinStore>()(persist((set) => ({
    ...initializeState,
    setGridPinStore(gridPins) {
        set((state) => ({
            orderGroups: gridPins?.orderGroups || state?.orderGroups,
            shippingManagement: gridPins?.shippingManagement || state?.shippingManagement,
            issueOrders: gridPins?.issueOrders || state?.issueOrders,
            refundOrders: gridPins?.refundOrders || state?.refundOrders,
            groupOrders: gridPins?.groupOrders || state?.groupOrders,
        }))
    },
    clearStore: () => {
        set(initializeState)
    }
}), {
    name: 'flowing-mall-grid-pin-storage',
    storage: createJSONStorage(() => localStorage)
}))